import React from "react";

const Containercontact = () => {
  return (
    <div className="contactus-section py-5">
      <div className="container">
        <h3 className="fw-bold mb-3">Contact Us</h3>
        <div className="privacy-border mb-4"></div>

        <div className="row g-3">
          
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm p-3 h-100">
              <div className="d-flex align-items-center">
                <div className="bskcontact-icon me-3">
                  <a href="tel:8668160894">
                    <i className="fa-solid fa-phone icon-contact"></i>
                  </a>
                </div>
                <div>
                  <h5 className="mb-1">Call Us</h5>
                  <span className="text-muted">8668160894</span>
                </div>
              </div>
            </div>
          </div>

        
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm p-3 h-100">
              <div className="d-flex align-items-center">
                <div className="bskcontact-icon me-3">
                  <a
                    href="https://wa.me/8668160894"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-whatsapp icon-contact"></i>
                  </a>
                </div>
                <div>
                  <h5 className="mb-1">WhatsApp</h5>
                  <span className="text-muted">8668160894</span>
                </div>
              </div>
            </div>
          </div>

          {/* EMAIL */}
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm p-3 h-100">
              <div className="d-flex align-items-center">
                <div className="bskcontact-icon me-3">
                  <a href="mailto:bskboutique@gmail.com">
                    <i className="fa-regular fa-envelope icon-contact"></i>
                  </a>
                </div>
                <div>
                  <h5 className="mb-1">Email</h5>
                  <span className="text-muted">bskboutique@gmail.com</span>
                </div>
              </div>
            </div>
          </div>

          {/* SOCIAL */}
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm p-3 h-100">
              <h5 className="mb-2">Follow Us</h5>
              <div className="d-flex gap-3">
                <ul className="d-flex p-0">
                  {/* <a
                    className="fb-icon text-decoration-none"
                    href="https://www.facebook.com/bskofcl/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-facebook-f icon-footer"></i>
                  </a> */}

                  <a
                    className="insta-icon text-decoration-none"
                    href="https://www.instagram.com/bskboutique?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-instagram icon-footer"></i>
                  </a>

                  <a
                    className="whatsapp-icon text-decoration-none"
                    href="https://wa.me/8668160894"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-whatsapp icon-footer"></i>
                  </a>
                </ul>
              </div>
            </div>
          </div>

          {/* ADDRESS */}
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm p-3 h-100">
              <div className="d-flex align-items-start">
                <div className="bskcontact-icon me-3">
                  <i className="fa-solid fa-location-dot icon-contact"></i>
                </div>
                <div>
                  <h5 className="mb-1">Address</h5>
                  <p className="text-muted mb-0">
                    Bskboutique, Muhavoor
                    <br />
                    Rajapalayam — Tamil Nadu
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Containercontact;
